var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip-group',_vm._l((_vm.roles),function(role){return _c('v-chip',{key:role.value,attrs:{"small":"","dark":_vm.dark,"color":role.color}},[_vm._v(" "+_vm._s(role.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }